import { render, staticRenderFns } from "./mo-environment-header.html?vue&type=template&id=08c4d85c&scoped=true&external"
import script from "./mo-environment-header.ts?vue&type=script&lang=ts&external"
export * from "./mo-environment-header.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-environment-header.vue?vue&type=style&index=0&id=08c4d85c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c4d85c",
  null
  
)

export default component.exports